export const customTemplateEndpoints = (builder) => ({
  getCustomTemplates: builder.query({
    query: (args = {}) => {
      const { searchTerm = null, pageNumber = 1, pageSize = 10 } = args;

      const params = {};
      if (searchTerm !== null && searchTerm !== undefined) {
        params.searchTerm = searchTerm;
      }
      if (pageNumber !== null && pageNumber !== undefined) {
        params.pageNumber = pageNumber;
      }
      if (pageSize !== null && pageSize !== undefined) {
        params.pageSize = pageSize;
      }

      return {
        url: '/admin/custom-templates',
        method: 'GET',
        params,
      };
    },
    transformResponse: (response) => ({
      data: response?.data ?? [],
      totalRecords: response?.totalRecords ?? 0,
      success: !!response?.success,
      message: response?.message ?? '',
    }),
    providesTags: (result) => {
      const rows = result && Array.isArray(result.data) ? result.data : [];
      if (!rows.length) return [{ type: 'CustomTemplate', id: 'LIST' }];

      return [
        ...rows.map((row) => ({
          type: 'CustomTemplate',
          id: row.id ?? 'ROW',
        })),
        { type: 'CustomTemplate', id: 'LIST' },
      ];
    },
  }),

  saveCustomTemplate: builder.mutation({
    query: (payload) => ({
      url: '/admin/custom-templates',
      method: 'POST',
      body: payload,
    }),
    invalidatesTags: [{ type: 'CustomTemplate', id: 'LIST' }],
  }),

  deleteCustomTemplate: builder.mutation({
    query: (id) => ({
      url: `/admin/custom-templates/${id}`,
      method: 'DELETE',
    }),
    invalidatesTags: [{ type: 'CustomTemplate', id: 'LIST' }],
  }),
});
